import React from 'react';
import ReactModal from 'react-modal';
import * as VeilederLogikk from './Veileder';
import GResultatContainer from './Components/G-ResultatComponent';
import HResultatContainer from './Components/H-ResultatComponent';
import IResultatContainer from './Components/I-ResultatComponent';
import Valg from '../Shared/Scripts/Models/Valg';
import NumberInputStegContainer, { NumberFormatter } from '../Shared/Scripts/Components/NumberInputStegComponent';
import { tilPengerFormat, fraPengerFormat } from '../Shared/Scripts/Utilities/Formatters';
import AStotteValg from './Utilities/A-StudiestotteValg';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import BSemesterValg from './Utilities/B-SemestertypeValg';
import DBostedValg from './Utilities/D-BostedValg';
import ESpValg from './Utilities/E-SkolepengerValg';
import * as ValgTypes from './Store/Valg/Types';
import VeilederHounDto from './Models/VeilederHounDto';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { VeilederHounAppState } from './Store';
import { connect } from 'react-redux';
import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { ResultatValg, ResultatValgValidering } from './Store/Resultat/Types';
import * as Validering from './Utilities/ValideringParameters';
import * as Ids from './Ids';
import contentResolver, { resolveRawText } from '../Shared/Scripts/Utilities/EpiContentResolver';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { ValideringsResultat } from '../Shared/Scripts/Models/ValideringsResultat';
import { updateValidation } from './Store/Resultat/Actions';
import { Satser } from './Utilities/SatserApi';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import SiteImproveHandler, { SiteImproveState, SiteImproveEvents, SiteImproveKategorier } from '../Shared/Scripts/Utilities/SiteImproveEventsHandler';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederHounDto>();
const NumberInputStegComponent = NumberInputStegContainer<VeilederHounDto>();

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, dispatchUpdateValidering, epiContext, satser } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;

        if (resultat.visGenerellFeil || epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            let resultatElement: JSX.Element | undefined;
            let fordelingResultat: JSX.Element | undefined;
            let utbetalingsPlanElement: JSX.Element | undefined;

            if (resultat.visResultat && satser != null) {
                const stipendOgLan = VeilederLogikk.beregnStipendOgLan(valg, resultat, satser);
                const utbetalingsplan = VeilederLogikk.utbetalingsplan(valg, resultat, stipendOgLan, satser);
                if (valg.visUtbetalingsplan) {
                    utbetalingsPlanElement = <IResultatContainer utbetalingsplan={utbetalingsplan} />;
                }

                resultatElement = (
                    <GResultatContainer
                        idA={VeilederLogikk.getA(valg)}
                        idB={VeilederLogikk.getB(valg)}
                        verdiF={resultat.visBoksF ? valg.fSpBelop || 0 : 0}
                        resultat={stipendOgLan}
                        utbetalingsplan={utbetalingsplan}
                    />
                );
                if (resultat.visFordeling) {
                    const andelStipendOgLan = VeilederLogikk.beregnAndelStipendOgLan(
                        valg,
                        resultat,
                        stipendOgLan,
                        satser,
                    );
                    fordelingResultat = (
                        <HResultatContainer verdiD={VeilederLogikk.getD(valg)} resultat={andelStipendOgLan} />
                    );
                }
            }

            function registerSiteImproveEvents(): void {
                // Veilederen vet ikke om den selv er i A/B eller ikke, og i så fall, om den er utfordrer eller ikke, men kjernesiden vet det
                const erABTest: boolean = document.getElementById('abtesting')?.attributes['data-erabtest']?.value as string === 'True';
                const erUtfordrer: boolean = document.getElementById('abtesting')?.attributes['data-erutfordrer']?.value as string === 'True';

                if(!SiteImproveState.Startet) {
                    if (resultat.visBoksB || resultat.visBoksBx || resultat.visBoksE) {
                        //veileder påstartet
                        SiteImproveState.Startet = true;
                        let siteImproveAction: string = SiteImproveEvents.VeilederStart;

                        if (erABTest) {
                            siteImproveAction = erUtfordrer ? SiteImproveEvents.VeilederKontrollStart : SiteImproveEvents.VeilederUtfordrerStart;
                        }

                        SiteImproveHandler.registerSiteImproveEvent(SiteImproveKategorier.Veileder, siteImproveAction, SiteImproveHandler.hentOverskrift());
                    }
                }

                if(!SiteImproveState.Fullfort) {
                    if(resultat.visResultat) {
                        //veileder fullført
                        SiteImproveState.Fullfort = true;
                        let siteImproveAction: string = SiteImproveEvents.VeilederFullfort;

                        if (erABTest) {
                            siteImproveAction = erUtfordrer ? SiteImproveEvents.VeilederUtfordrerFullfort : SiteImproveEvents.VeilederKontrollFullfort;
                        }

                        SiteImproveHandler.registerSiteImproveEvent(SiteImproveKategorier.Veileder, siteImproveAction, SiteImproveHandler.hentOverskrift());
                    }
                }
            }

            return (
                <div className="c-veileder">
                    {registerSiteImproveEvents()}
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittel')}
                        forklaring={contentResolver(epiContext, 'infoUtdanningslengde')}
                        sporsmal="ledetekstVelgLengde"
                        valg={AStotteValg.aValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aStotte: nyttValg });
                        }}
                        neverCollapse={true}
                        value={valg.aStotte}
                    />
                    {resultat.visBoksB && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksB}
                            tittel={contentResolver(epiContext, 'tittelSemestre')}
                            forklaring={contentResolver(epiContext, 'infoSemestre')}
                            sporsmal="ledetekstVelgAntallSemester"
                            valg={BSemesterValg.bValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bSemester: nyttValg });
                            }}
                            value={valg.bSemester}
                        />
                    )}
                    {resultat.visBoksBx && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksBx}
                            tittel={contentResolver(epiContext, 'tittelHalvtSemester')}
                            forklaring={contentResolver(epiContext, 'infoHalvtSemester')}
                            sporsmal="ledetekstHalvtSemester"
                            valg={BSemesterValg.bxValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bxSemester: nyttValg });
                            }}
                            value={valg.bxSemester}
                        />
                    )}
                    {resultat.visBoksC && (
                        <NumberInputStegComponent
                            sporsmalId={Ids.BoksC}
                            sporsmal="ledetekstAntallStudiepoengHeltid"
                            tittel={contentResolver(epiContext, 'tittelStudiepoengDeltid')}
                            forklaring={contentResolver(epiContext, 'infoStudiepoengDeltid')}
                            inputId="c1"
                            placeholder="00,0"
                            decimals={1}
                            value={valg.cSp}
                            postfix={resolveRawText(epiContext, 'benevnelseStudiepoeng')}
                            ctaText="ctaGaVidere"
                            isSmall={true}
                            validering={Validering.CStudiepoengValidering}
                            onInputChange={(nyttValg: number | undefined): void => {
                                dispatchUpdateValg({ cSp: nyttValg });
                            }}
                            onValidationChanged={(result: ValideringsResultat | undefined): void =>
                                dispatchUpdateValidering({ cValidation: result })
                            }
                        />
                    )}

                    {resultat.visBoksCx && (
                        <NumberInputStegComponent
                            sporsmalId={Ids.BoksCx}
                            tittel={contentResolver(epiContext, 'tittelStudiepoengDeltid')}
                            sporsmal="ledetekstAntallStudiepoengDeltid"
                            forklaring={contentResolver(epiContext, 'infoStudiepoengDeltid')}
                            inputId="cx1"
                            placeholder="00,0"
                            decimals={1}
                            value={valg.cxSp}
                            postfix={resolveRawText(epiContext, 'benevnelseStudiepoeng')}
                            ctaText="ctaGaVidere"
                            isSmall={true}
                            validering={Validering.CxStudiepoengValidering}
                            onInputChange={(nyttValg: number | undefined): void => {
                                dispatchUpdateValg({ cxSp: nyttValg });
                            }}
                            onValidationChanged={(result: ValideringsResultat | undefined): void =>
                                dispatchUpdateValidering({ cXValidation: result })
                            }
                        />
                    )}
                    {resultat.visBoksE && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksE}
                            tittel={contentResolver(epiContext, 'tittelSkolepenger')}
                            forklaring={contentResolver(epiContext, 'infoSkolepenger')}
                            sporsmal="ledetekstSkolepenger"
                            valg={ESpValg.eValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ eSkolepenger: nyttValg });
                            }}
                            value={valg.eSkolepenger}
                        />
                    )}
                    {resultat.visBoksF &&
                        satser != null &&
                        this.skolepengerBoks(
                            valg,
                            resultat,
                            locale,
                            valuta,
                            dispatchUpdateValg,
                            dispatchUpdateValidering,
                            epiContext,
                            satser,
                        )}
                    {resultatElement}
                    {utbetalingsPlanElement}
                    {resultat.visResultat && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksD}
                            tittel={contentResolver(epiContext, 'tittelBosituasjon')}
                            forklaring={contentResolver(epiContext, 'infoBosituasjon')}
                            sporsmal="ledetekstBosituasjon"
                            valg={DBostedValg.dValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ dBosted: nyttValg });
                            }}
                            value={valg.dBosted}
                            classModifier="c-veileder__panel--input-white"
                            neverCollapse={true}
                        />
                    )}
                    {fordelingResultat}
                </div>
            );
        } else {
            return <p>Laster...</p>;
        }
    }

    private skolepengerBoks(
        valg: ValgTypes.ValgState,
        resultat: ResultatValg,
        locale: string,
        valuta: string,
        dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void,
        dispatchUpdateValidering: (result: Partial<ResultatValgValidering>) => void,
        epiContext: EpiContext<VeilederHounDto>,
        satser: Satser,
    ): React.ReactNode {
        const maxSkolepenger = VeilederLogikk.maksSkolepenger(valg, resultat, satser);
        const skolepengerInfoKey = VeilederLogikk.skolepengerInfo(valg);
        const infoElement = (
            <div>
                <p>
                    {contentResolver(epiContext, skolepengerInfoKey)}
                    <span> {tilPengerFormat(maxSkolepenger, locale)}&nbsp;{valuta}.</span>
                </p>
                {contentResolver(epiContext, 'infoSkolepengerBelop')}
            </div>
        );

        const formatter: NumberFormatter = {
            toFormattetString: (v: number): string => tilPengerFormat(v, locale),
            toParsableAsNumber: (v: string): string => fraPengerFormat(v, locale),
        };

        return (
            <NumberInputStegComponent
                sporsmalId={Ids.BoksF}
                sporsmal="ledetekstSkolepengerBelop"
                tittel={contentResolver(epiContext, 'tittelSkolepengerBelop')}
                forklaring={infoElement}
                inputId="f1"
                placeholder="0"
                decimals={0}
                value={valg.fSpBelop}
                postfix={valuta}
                ctaText="ctaBekreft"
                validering={Validering.fSkolepengerValidering(maxSkolepenger, epiContext.locale)}
                numberDisplayFormatter={formatter}
                onInputChange={(nyttValg: number | undefined): void => {
                    dispatchUpdateValg({ fSpBelop: nyttValg });
                }}
                onValidationChanged={(result: ValideringsResultat | undefined): void =>
                    dispatchUpdateValidering({ fValidation: result })
                }
                preValidation={resultat.fValidation}
                validationChecksum={maxSkolepenger}
            />
        );
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederHounDto>;
    resultat: ResultatValg;
    satser: Satser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
    dispatchUpdateValidering: (validation: Partial<ResultatValgValidering>) => void;
}

const mapDispatchToProps = (
    dispatch: ThunkDispatch<VeilederHounAppState, {}, AnyAction>,
    ownProps: AppOwnProps,
): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
    dispatchUpdateValidering: (validation: Partial<ResultatValgValidering>): void => {
        dispatch(updateValidation(validation));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederHounAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
